// src/components/DatePicker.js
import React from "react";
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const CustomDatePicker = ({ selectedDate, onDateChange }) => {
  const [value, setValue] = React.useState(dayjs(selectedDate));

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        value={value}
        onChange={(newValue) => {
          setValue(newValue);
          onDateChange(newValue);
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
